import HomepageHero from "../components/HomepageHero";
// import CallToAction from "../components/CallToAction";
// import ForDevelopers from "../components/ForDevelopers";
import Navbar from "../components/Navbar";
import Clients from "../components/Clients";
import Footer from "../components/Footer";
import Announcement from "../components/Announcement";
// import Products from "../components/Products";
// import Statistics from "../components/Statistics";
import {Helmet} from "react-helmet";
import Features from "../components/Features";
// import Api from "../components/Api";
import Testimonials from "../components/Testimonials";
import ScrollToTop from "../components/ScrollToTop";
import Industry from "../components/Industry";
import Developers from "../components/Developers";
import Products2 from "../components/Products2";





function LandingPage() {

  return (
    <div>
        <Helmet>
                <meta charSet="utf-8" />
                <title>Whistle Pulse - The Pan African Messaging Platform</title>
                <link rel="canonical" href="https://whistlepulse.com" />
                {/* <!-- Required Meta Tags Always Come First --> */}
  {/* <meta charset="utf-8">
  <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1">
  <link rel="canonical" href="https://preline.co/">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <meta name="description" content="This example is a quick exercise to illustrate how fixed to top navbar works using Tailwind CSS. As you scroll, it will remain fixed to the top of your browser's viewport.">

  <meta name="twitter:site" content="@preline">
  <meta name="twitter:creator" content="@htmlstream">
  <meta name="twitter:card" content="summary_large_image">
  <meta name="twitter:title" content="Sticky Header using Tailwind CSS | Preline UI, crafted with Tailwind CSS">
  <meta name="twitter:description" content="This example is a quick exercise to illustrate how fixed to top navbar works using Tailwind CSS. As you scroll, it will remain fixed to the top of your browser's viewport.">
  <meta name="twitter:image" content="../../assets/img/og-image.png">

  <meta property="og:url" content="https://preline.co/">
  <meta property="og:locale" content="en_US">
  <meta property="og:type" content="website">
  <meta property="og:site_name" content="Preline">
  <meta property="og:title" content="Sticky Header using Tailwind CSS | Preline UI, crafted with Tailwind CSS">
  <meta property="og:description" content="This example is a quick exercise to illustrate how fixed to top navbar works using Tailwind CSS. As you scroll, it will remain fixed to the top of your browser's viewport.">
  <meta property="og:image" content="../../assets/img/og-image.png"> */}
            </Helmet>
    <Announcement/>
     <Navbar/>
     <HomepageHero/>
    {/* <Clients titleColor="text-gray-600" logoColor="text-gray-500" /> */}
    <div className="landing-section-reveal landing-delay-1">
     <Products2/>
    </div>
     {/* <Products/> */}
    <div className="landing-section-reveal landing-delay-2">
     <Features/>
    </div>
   
       {/* <Api/> */}
    <div className="landing-section-reveal landing-delay-3">
    <Developers/>
    </div>
    
     {/* <Statistics/> */}
    
     {/* <ForDevelopers/> */}
    {/* <div className="landing-section-reveal landing-delay-4">
     <Industry/>
    </div> */}
    <div className="landing-section-reveal landing-delay-5">
     <Testimonials/>
    </div>
   

     <Footer/>
     <ScrollToTop/>
    </div>
  );
}

export default LandingPage;
